import { Image } from "@/components/Elements";

export type PostHeaderProps = {
  createdByImgUrl: string;
  createdBy: string;
  createdOn?: string;
  hideName?: boolean;
};

export const PostHeader = ({
  createdByImgUrl,
  createdBy,
  createdOn,
  hideName,
}: PostHeaderProps) => {
  return (
    <>
      <Image
        src={createdByImgUrl}
        isApiUrl
        className="w-[30px] h-[30px] rounded-[50px] border border-[#d3d3d3]"
      />
      {!hideName && (
        <div className="ml-[10px]">
          <div className="text-[13px] font-bold">{createdBy}</div>
          <div className="text-[10px] text-[#808080]">{createdOn}</div>
        </div>
      )}
    </>
  );
};
